export enum UserPlatformTypeEnum {
  Writer = 'WRITER',
  Reader = 'READER',
}
